import React from 'react';
import { useIntl } from 'react-intl';

import { Text, TextType } from 'ui-components/components/text';

import { PlaceholderWrapper, PlaceholderBody } from '.';
import PlaceholderImage from './shipping-box.svg';

import messages from './messages';

export const NoFlaggedReturnsPlaceholder = () => {
  const intl = useIntl();

  return (
    <PlaceholderWrapper>
      <img alt={intl.formatMessage(messages.noReturnsAltText)} src={PlaceholderImage} />
      <PlaceholderBody>
        <Text textType={TextType.H2} value={messages.noFlaggedReturnsHeader} />
        <Text textType={TextType.Paragraph} value={messages.noFlaggedReturnsDescription} />
      </PlaceholderBody>
    </PlaceholderWrapper>
  );
};
